import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useGetIndividualTeamQuery } from '../../../app/Slices/SevenDayApiSlice';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import ActiveUserList from '../../components/Teams/ActiveUserList';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import TeamsForm from '../../components/Teams/TeamsForm';

const EditTeamsPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const navigate = useNavigate();
    const theme = useTheme();

    const departmentId = window.location.href.split('/')[4];
    const url = departmentId ? `/departments/${departmentId}` : '';
    const { data: getIndividualTeam, isLoading } = useGetIndividualTeamQuery(
        url,
        { skip: !url },
    );

    const handleBackButton = () => {
        navigate(`/teams`);
    };

    return (
        <>
            {!url || isLoading ? (
                <Grid
                    sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LoadingComponent />
                </Grid>
            ) : (
                <Grid
                    sx={{
                        width: '100%',
                        minWidth: 0,
                        justifyContent: 'left',
                        alignItems: 'center',
                        position: 'relative',
                    }}
                >
                    <Typography
                        variant='h1'
                        sx={{
                            textTransform: 'uppercase',
                            mb: 3,
                            pr: 5,
                            overflowWrap: 'anywhere',
                        }}
                    >
                        Team profile
                    </Typography>
                    <TeamsForm team={getIndividualTeam} />
                    <ActiveUserList team={getIndividualTeam} />
                    <CustomButton
                        onClick={handleBackButton}
                        color='primary'
                        sx={{
                            marginTop: '24px',
                            marginLeft: !isMobile || !isIpad ? '-8px' : '-18px',
                            '&:hover': {
                                cursor: 'pointer',
                                color: theme.palette.textAccent.main,
                                backgroundColor: 'transparent',
                                background: 'none',
                            },
                        }}
                    >
                        <ArrowBackIcon />{' '}
                        <Typography
                            sx={{
                                fontSize: '12px',
                                paddingLeft: '5px',
                            }}
                        >
                            Back to list
                        </Typography>
                    </CustomButton>
                </Grid>
            )}
        </>
    );
};

export default EditTeamsPage;
